import { useState } from "react";

/**
 * Hook for managing protection/modal states
 */
export const useProtectionState = () => {
  const [showProtectionModal, setShowProtectionModal] = useState(false);
  const [protectionMethods, setProtectionMethods] = useState([]);
  const [selectedProtectionMethod, setSelectedProtectionMethod] = useState("");
  const [loadingProtectionMethods, setLoadingProtectionMethods] = useState(false);
  const [applyingProtection, setApplyingProtection] = useState(false);
  const [protectionResult, setProtectionResult] = useState(null);
  const [previewMode] = useState(true);

  const [showModeSelectionModal, setShowModeSelectionModal] = useState(false);
  const [showScriptModal, setShowScriptModal] = useState(false);
  const [selectedDbType, setSelectedDbType] = useState("");
  const [selectedScriptProtectionType, setSelectedScriptProtectionType] = useState("");
  const [scriptProtectionCategory, setScriptProtectionCategory] = useState("");
  const [generatingScript, setGeneratingScript] = useState(false);
  const [scriptDownloadUrl, setScriptDownloadUrl] = useState(null);
  const [scriptProtectionMethods, setScriptProtectionMethods] = useState({
    reversible: [],
    irreversible: [],
  });

  return {
    // Protection modal
    showProtectionModal,
    setShowProtectionModal,
    protectionMethods,
    setProtectionMethods,
    selectedProtectionMethod,
    setSelectedProtectionMethod,
    loadingProtectionMethods,
    setLoadingProtectionMethods,
    applyingProtection,
    setApplyingProtection,
    protectionResult,
    setProtectionResult,
    previewMode,

    // Script modal
    showModeSelectionModal,
    setShowModeSelectionModal,
    showScriptModal,
    setShowScriptModal,
    selectedDbType,
    setSelectedDbType,
    selectedScriptProtectionType,
    setSelectedScriptProtectionType,
    scriptProtectionCategory,
    setScriptProtectionCategory,
    generatingScript,
    setGeneratingScript,
    scriptDownloadUrl,
    setScriptDownloadUrl,
    scriptProtectionMethods,
    setScriptProtectionMethods,
  };
};
